import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import { search_icon, view_icon } from "../../assets/imgs";
import { admin_list } from "../redux/api/dummyJson";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { useLazySalesListQuery } from "../redux/api/api";
import moment from "moment";

const Sales = () => {
  const navigate = useNavigate();
  const [fromdate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [search, setSearch] = useState("");
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [list, setList] = useState([]);
  const [count, setCount] = useState();
  const [givenpermissions, setGivenpermissions] = useState([]);

  const [getSalesList] = useLazySalesListQuery();

  const rolePermissions = JSON.parse(localStorage.getItem("permissions"));

  const salesList = (pageno, fromdate, toDate, search) => {
    const formdata = new FormData();
    formdata.append("page", pageno);
    formdata.append("per_page", 10);

    formdata.append("row", 10);

    let params = `?page=${pageno}&row=10`;

    if (fromdate && toDate) {
      params = params + "&from_date=" + moment(fromdate).format("YYYY-MM-DD");
      params = params + "&to_date=" + moment(toDate).format("YYYY-MM-DD");
    }
    if (search) {
      params = params + "&search=" + search;
    }

    setFromDate(fromdate);
    setToDate(toDate);
    setSearch(search);

    getSalesList(params)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          temp.push(obj);
        });
        setCount(res?.data?.length);
        setList(temp);
        setPagecount(res?.pagination);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    salesList(pageno, fromdate, toDate, search);
  }, [pageno]);

  useEffect(() => {
    setGivenpermissions(localStorage.getItem("permission"));
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
          // return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Admin",
        accessor: "admin_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Sales Count",
        accessor: "approved_property_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes("CAN-STATUS-SALES") && (
                  <button
                    onClick={() =>
                      navigate("/sales-view", {
                        state: { type: "view", id: row.original.admin_id },
                      })
                    }
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Sales({count})
        </h2>
        <div className="d-flex ac-je gap-3">
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            From Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={fromdate}
              onChange={(e) => salesList(1, e, toDate, search)}
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="From Date"
              type="date"
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            To Date
          </label>
          <div className="w-15">
            <DatePicker
              type="date"
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="To Date"
              selected={toDate}
              onChange={(e) => salesList(1, fromdate, e, search)}
            />
          </div>
          <div className="search-input">
            <input
              onChange={(e) => salesList(1, fromdate, toDate, e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
    </div>
  );
};

export default Sales;
